var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useEffect, useState } from 'react';
import Home from 'src/pages/home';
import './App.scss';
import { Route, Routes } from 'react-router';
import NavBar from './NavBar';
import Footer from './Footer';
import Hamburger from './Hamburger';
import Popup from './Popup';
import { TextMapContext, PopupContext, Web3Context, AddressContext, NetworkIdContext, FeedBalanceContext } from 'src/context';
import { getTextMap } from 'src/common/text';
import Mint from '../Mint';
import Feed from '../Feed';
var App = function (props) {
    var locale = props.locale, web3Service = props.web3Service;
    var _a = useState(false), hamburgerActive = _a[0], setHamburgerActive = _a[1];
    var _b = useState(null), popup = _b[0], setPopup = _b[1];
    var _c = useState(''), address = _c[0], setAddress = _c[1];
    var _d = useState(-1), networkId = _d[0], setNetworkId = _d[1];
    var _e = useState(0), feedBalacne = _e[0], setFeedBalance = _e[1];
    useEffect(function () {
        if (locale != 'ko') {
            document.title = 'SigorJabuJong';
        }
        (function LoadWallet() {
            return __awaiter(this, void 0, void 0, function () {
                var walletType, _address, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            walletType = localStorage.getItem('walletType');
                            if (!(!web3Service.wallet && walletType)) return [3 /*break*/, 6];
                            _address = [];
                            if (!(walletType === 'kaikas')) return [3 /*break*/, 2];
                            return [4 /*yield*/, web3Service.connectKaikas(setAddress)];
                        case 1:
                            _address = _b.sent();
                            _b.label = 2;
                        case 2:
                            if (!(walletType === 'metamask')) return [3 /*break*/, 4];
                            return [4 /*yield*/, web3Service.connectMetamask(setAddress)];
                        case 3:
                            _address = _b.sent();
                            _b.label = 4;
                        case 4:
                            setAddress(_address);
                            setNetworkId(web3Service.getChainId());
                            _a = setFeedBalance;
                            return [4 /*yield*/, web3Service.getFeedBalance(_address)];
                        case 5:
                            _a.apply(void 0, [_b.sent()]);
                            _b.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            });
        })();
    }, []);
    return (React.createElement(AddressContext.Provider, { value: [address, setAddress] },
        React.createElement(NetworkIdContext.Provider, { value: [networkId, setNetworkId] },
            React.createElement(Web3Context.Provider, { value: [web3Service] },
                React.createElement(TextMapContext.Provider, { value: [getTextMap(locale), locale] },
                    React.createElement(PopupContext.Provider, { value: setPopup },
                        React.createElement(FeedBalanceContext.Provider, { value: [feedBalacne, setFeedBalance] },
                            React.createElement("div", { className: "app" },
                                React.createElement(NavBar, { setHamburgerActive: setHamburgerActive }),
                                React.createElement(Hamburger, { active: hamburgerActive, setActive: setHamburgerActive }),
                                React.createElement(Routes, null,
                                    React.createElement(Route, { index: true, element: React.createElement(Home, null) }),
                                    React.createElement(Route, { path: '/mint', element: React.createElement(Mint, null) }),
                                    React.createElement(Route, { path: '/feed', element: React.createElement(Feed, null) })),
                                React.createElement(Footer, null),
                                React.createElement(Popup, { popup: popup })))))))));
};
export default App;
